/** Course Help words (#1294 R3). The server states the audience and retention; these frame them. */
export const helpWords = {
  help: "Help",
  helpQuestions: "Help questions",
  learnerJob: "Ask this course's teaching team for help and find their replies again.",
  teachingJob: "Read and answer the Help questions learners in this course have asked.",
  askForHelp: "Ask for help",
  readReply: "Read reply",
  readThread: "Read your questions",
  askAnother: "Ask another question",
  askAboutInstead: (label: string) => `Ask about ${label} instead`,
  threadJob: "Read your questions to this course's teaching team and their replies.",
  messages: (count: number) => (count === 1 ? "1 message" : `${count} messages`),
  replyVerb: "Reply",
  readThreadVerb: "Read thread",
  noQuestions: "No questions yet",
  waitingForTeam: "Waiting for the teaching team",
  answered: "Answered",
  newReplies: (count: number) => (count === 1 ? "1 new reply" : `${count} new replies`),
  unanswered: (count: number) => `${count} unanswered`,
  allAnswered: "All answered",
  noLearnerAsked: "No learner has asked for help in this course yet.",
  thread: "Your questions and replies",
  question: "Your question",
  reply: "Your reply",
  questionLabel: "Write your question",
  replyLabel: "Write your reply",
  writeQuestion: "Write your question before you send it.",
  writeReply: "Write your reply before you send it.",
  sendQuestion: "Send to teaching team",
  sendReply: "Send reply",
  whenYouSend: "When you send",
  questionGoes: "Your question goes to this course's teaching team.",
  questionAbout: (label: string) => `Your question goes to this course's teaching team, about ${label}.`,
  keptUntil: (date: string) => `Kept until ${date}.`,
  keptAfterTerm: "Kept for 12 months after the course's term ends.",
  replyGoes: (name: string, count: number) =>
    count > 0 ? `Your reply goes to ${name} and answers ${count === 1 ? "their open question" : `their ${count} open questions`}.` : `Your reply goes to ${name}.`,
  replyNamed: "Your name is shown on the reply. Every teacher assigned to this course can read it.",
  aboutReference: (label: string) => `About ${label}`,
  wholeCourse: "Ask about the whole course instead",
  cameFromSession: "the session you came from",
  cameFromWork: "the work you came from",
  sessionReference: "About this session",
  workReference: "About this work",
  askAboutSession: "Ask the teaching team about this session",
  askAboutWork: "Ask the teaching team about this work",
  sent: "Sent to the teaching team",
  replySent: "Reply sent",
  notSent: "Not sent",
  sendUnknown: "We could not confirm this was sent. Check before you send it again.",
  checkStatus: "Check if it was sent",
  checkOnly: "Check reads what was saved. It never sends again.",
  notSentCheck: "It was not sent. Your words are kept here; send them when you are ready.",
  sending: "Sending",
  you: "You",
  teacher: "Teacher",
  learner: "Learner",
  open: "Waiting for an answer",
  readFailed: "Help could not be read.",
  threadFailed: "This thread could not be read.",
  threadStale: "This thread could not refresh. Read it again before you reply.",
  readAgain: "Read the thread again",
  readingThread: "Reading this thread",
  readBeforeReply: "Read the thread before you reply.",
  refused: "Help in this course is not open to you.",
  threadRefused: "You can no longer read this thread.",
  learnerEnded: "The course has ended for this learner. You can still answer what is outstanding.",
  nothingOutstanding: "The course has ended for this learner and nothing is outstanding.",
  newSince: "New",
} as const;
